import { useLocation, useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { TimerReset } from "lucide-react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import {
  getorderno,
  getqrdetails,
  SaveSosOrder,
  getdata,
} from "../api/service";
import confetti from "canvas-confetti";
import React, { useRef } from "react";
function CheckoutPage() {
  const location = useLocation();
  
  const navigate = useNavigate();
  const [qrLoaded, setQrLoaded] = useState(false);
  const [startTimer, setStartTimer] = useState(false);

  // hidden popup

  const [secretStep, setSecretStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [pin, setPin] = useState(["", "", "", ""]);
  const [error, setError] = useState("");

  const inputsRef = useRef([]);
  const keyboardRef = useRef(null);

  const CORRECT_PIN = "2026";

  /* ---------------- SECRET CLICK FLOW ---------------- */

  const handleSecretClick = (value) => {
    if (secretStep === 0 && value === "c") setSecretStep(1);
    else if (secretStep === 1 && value === "to") setSecretStep(2);
    else if (secretStep === 2 && value === "pay") {
      setOpen(true);
      setSecretStep(0);
    } else setSecretStep(0);
  };

  /* ---------------- PIN INPUT ---------------- */

  const handleKeyboardPress = (button) => {
    let newPin = [...pin];

    if (button === "{bksp}") {
      for (let i = 3; i >= 0; i--) {
        if (newPin[i]) {
          newPin[i] = "";
          break;
        }
      }
    } else if (button === "{enter}") {
      validatePin();
      return;
    } else {
      for (let i = 0; i < 4; i++) {
        if (!newPin[i]) {
          newPin[i] = button;
          break;
        }
      }
    }

    setPin(newPin);
  };

  const validatePin = () => {
    if (pin.join("") === CORRECT_PIN) {
      setError("");
      setOpen(false);
      setShowSuccessPopup(true);
      setPin(["", "", "", ""]);
    } else {
      setError("Invalid PIN");
      setPin(["", "", "", ""]);
    }
  };

  // ---------- Print Style ----------
  const printhtmlstyle = `
    <style>
      @page { margin: 2px; }
      body, html { margin: 2px; padding: 2px; width: 100%; }
      #printelement { width: 270px; align-items: center; }
      .header { text-align: center; }
      .item-table { width: 95%; }
      .text-right { text-align: right !important; }
      .text-left { text-align: left !important; }
      .text-center { text-align: center !important; }
      tr.nb, thead.nb { border-top: 0; border-bottom: 0; }
      thead { border-bottom: 1px dashed black; border-top: 0; }
      h3, table, p {
        font-family: 'Comfortaa', sans-serif;
        font-size: 14px;
        font-weight: 545;
        border-collapse: collapse;
      }
      h3 { font-size: 16px; font-weight: 600; }
      hr { border-top: 1px dashed black; }
      tr.bt { border-top: 1px dashed black; }
      tr { padding-top: 5px; padding-bottom: 5px; }
  .token {
  font-size: 3rem;
  font-weight: 900;
  text-align: center;
  display: block;
  padding: 8px 0;
  margin: 10px auto;
  width: 220px;            /* Adjust width if needed */
  border: 4px ridge black; /* Ridge border */
  border-radius: 6px;      /* Slight rounded corners */
}
.not-paid-stamp {
  position: absolute;
  top: 25%;
  left: 20%;
  width: 40vw; /* Width relative to viewport width */
  display: block;
  transform: translate(-50%, -50%) rotate(-15deg);

  color: #9b0808;
  padding: 20px 60px;
  
  font-size: 38px;
  font-weight: 900;
  letter-spacing: 3px;
  text-transform: uppercase;
  opacity: 0.29;
  pointer-events: none;
  z-index: 0;
  font-family: Arial, sans-serif;
}


    </style>`;

  // ---------- Load Cart ----------
  const { cart = JSON.parse(localStorage.getItem("cart")) || [], total = 0 ,} =
    location.state || {};

  localStorage.setItem("cart", JSON.stringify(cart));
  const OrderItems = JSON.parse(localStorage.getItem("cart")) || [];

  // ---------- Store ID & Date ----------
  const storeId = localStorage.getItem("StoreId");
  const phone = localStorage.getItem("userPhone");
  const cstId = localStorage.getItem("custid");
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-GB").split("/").reverse().join("");

  const Macadd = localStorage.getItem("macAdrs");
  const CompId = localStorage.getItem("compId");
  const storeName = localStorage.getItem("StoreName");

  const [companyInfo, setCompanyInfo] = useState({
    CompanyName: "",
    StoreName: "",
    GsTno: "",
    ContactNo: "",
  });

  // useEffect(() => {
  //   async function fetchLayoutSetting() {
  //     const orderResponse = await getorderno(storeId);
  //     console.log(orderResponse.getOrderIndex);
  //     const orderNo = orderResponse.getOrderIndex[0].orderno || 0;
  //     console.log("🧾 OrderNo from API:", orderNo);

  //     // ✅ 2. Store OrderNo in localStorage
  //     localStorage.setItem("OrderNo", orderNo);
  //   }
  //   fetchLayoutSetting();
  // }, []);

  // ---------- Calculate Order ----------
  // -------------------- CALCULATE ORDER --------------------
  // -------------------- CALCULATE ORDER --------------------
  let billAmount = 0;
  let cgstTotal = 0;
  let sgstTotal = 0;
  let subtotalProd = 0;
  let subtotalAddn = 0;

  let subtotal = 0;
  let taxAmount = 0;

  const items = [];

  OrderItems.forEach((product) => {
    const taxRate = (product.tax1 ?? 0) + (product.tax2 ?? 0); // Total % GST
    const gstMultiplier = 1 + taxRate / 100;

    // 1️⃣ SUBTOTAL WITHOUT TAX (qty-based correct format)
    const rowSubtotalRaw =
      (product.sosPrice * product.quantity) / gstMultiplier;
    const rowSubtotal = parseFloat(rowSubtotalRaw.toFixed(2));
    subtotalProd += rowSubtotal;

    // 2️⃣ GST computed from RAW base (correct)
    const cgst = parseFloat(
      (
        (rowSubtotalRaw / product.quantity) *
        (product.tax1 / 100) *
        product.quantity
      ).toFixed(2),
    );
    const sgst = parseFloat(
      (
        (rowSubtotalRaw / product.quantity) *
        (product.tax2 / 100) *
        product.quantity
      ).toFixed(2),
    );

    cgstTotal += cgst;
    sgstTotal += sgst;

    // 3️⃣ MRP total
    billAmount += product.sosPrice * product.quantity;

    // 4️⃣ ADD MAIN ITEM
    items.push({
      ProductId: product.id,
      isAddon: false,
      ProductName: product.product_Name,
      Quantity: product.quantity,
      Price: parseFloat(product.sosPrice.toFixed()),
      Tax1: cgst,
      Tax2: sgst,
      SubTotal: rowSubtotal,
      TotalAmount: rowSubtotal,
      ImgUrl: product.product_Imageurl,
      Prod_Desc: product.product_Name,
    });

    // 5️⃣ ADDONS (same corrected qty-based logic)
    if (product.addons && product.addons.length > 0) {
      product.addons.forEach((addon) => {
        const addonTaxRate = (addon.tax1 ?? 0) + (addon.tax2 ?? 0);
        const addonGSTMul = 1 + addonTaxRate / 100;

        const addonSubtotalRaw = (addon.sosPrice * addon.qty) / addonGSTMul;
        const addonSubtotal = parseFloat(addonSubtotalRaw.toFixed(2));
        subtotalAddn += addonSubtotal;

        const addonCgst = parseFloat(
          (
            (addonSubtotalRaw / addon.qty) *
            (addon.tax1 / 100) *
            addon.qty
          ).toFixed(2),
        );
        const addonSgst = parseFloat(
          (
            (addonSubtotalRaw / addon.qty) *
            (addon.tax2 / 100) *
            addon.qty
          ).toFixed(2),
        );

        cgstTotal += addonCgst;
        sgstTotal += addonSgst;

        billAmount += addon.sosPrice * addon.qty;
        items.push({
          ProductId: addon.id,
          isAddon: true,
          ProductName: addon.name,
          Quantity: addon.qty,
          Price: parseFloat(addon.sosPrice.toFixed()),
          Tax1: addonCgst,
          Tax2: addonSgst,
          SubTotal: addonSubtotal,
          TotalAmount: addonSubtotal,
          ImgUrl: addon.product_Imageurl,
          Prod_Desc: addon.name,
        });
      });
    }
  });

  // -------------------- FINAL TOTALS --------------------
  subtotal = parseFloat((subtotalProd + subtotalAddn).toFixed(2));
  cgstTotal = parseFloat(cgstTotal.toFixed(2));
  sgstTotal = parseFloat(sgstTotal.toFixed(2));
  billAmount = parseFloat(billAmount.toFixed(2));
  taxAmount = parseFloat((cgstTotal + sgstTotal).toFixed(2));

  // -------------------- LOGS --------------------
  console.log("Subtotal:", subtotal);
  console.log("CGST:", cgstTotal);
  console.log("SGST:", sgstTotal);
  console.log("Grand Total (MRP):", billAmount);
  console.log("Items:", items);

  // ---- Final subtotal: (inclusive total - total tax) ----

  const orderDetails = {
    invoiceNo: "",
    orderDate: new Date().toLocaleDateString("en-GB").replace(/\//g, "-"),
    customerName: "Walk-in Customer",
    customerPhone: "",
    discount: 0,
    subtotal: parseFloat(subtotal.toFixed(2)),
    // cgst: parseFloat((taxAmount / 2).toFixed(2)),
    // sgst: parseFloat((taxAmount / 2).toFixed(2)),
    cgst: parseFloat((parseFloat(taxAmount.toFixed(2)) / 2).toFixed(2)),
    sgst: parseFloat((parseFloat(taxAmount.toFixed(2)) / 2).toFixed(2)),
    total: parseFloat(billAmount.toFixed(2)),
    paidAmount: parseFloat(billAmount.toFixed(2)),
    items,
  };

  const type = localStorage.getItem("orderType");
  console.log(type);
  // ---------- Print Receipt ----------
  // const printReceipt = async (invoiceNo, ordNo1) => {
  //   const compId = localStorage.getItem("compId");
  //   const strId = localStorage.getItem("StoreId");

  //   const { phoneNum, cusName } = location.state || {};
  //   try {
  //     const data = await getdata(compId, strId);

  //     if (data?.datas?.length > 0) {
  //       const info = data.datas[0];
  //       setCompanyInfo({
  //         CompanyName: info.companyName,
  //         StoreName: info.storeName,
  //         Address: info.address,
  //         City: info.city,
  //         GsTno: info.gsTno,
  //         ContactNo: info.contactNo,
  //       });
  //     }

  //     // Wait for state to update before using companyInfo
  //     const finalInfo = {
  //       CompanyName: data.datas?.[0]?.printStrName || "",
  //       StoreName: data.datas?.[0]?.storeName || "",
  //       Address: data.datas?.[0]?.address || "",
  //       City: data.datas?.[0]?.city || "",
  //       GsTno: data.datas?.[0]?.gsTno || "",
  //       ContactNo: data.datas?.[0]?.contactNo || "",
  //     };

  //     // ============================
  //     // 3) HEADER DETAILS
  //     // ============================
  //     const lines = [
  //       finalInfo.Address,
  //       finalInfo.City,
  //       finalInfo.ContactNo,
  //       `GSTIN: ${finalInfo.GsTno}`,
  //       `Receipt: ${invoiceNo}`,
  //       orderDetails.orderDate,
  //       phoneNum && `Customer PhoneNo: ${phoneNum}`, //  only if phone exists
  //       cusName && `Customer: ${cusName}`,
  //       `Order Type: ${type}`,
  //     ].filter(Boolean);

  //     const addressBlock = `<p>${lines.filter(Boolean).join("<br>")}</p>`;

  //     // ============================
  //     // 4) ITEM TABLE
  //     // ============================
  //     const allItemRows = orderDetails.items
  //       .map(
  //         (item) => `
  //       <tr>
  //         <td class="text-left">${item.Prod_Desc}</td>
  //         <td class="text-center">${item.Quantity}</td>
  //         <td class="text-right">₹${item.TotalAmount.toFixed(2)}</td>
  //       </tr>`
  //       )
  //       .join("");

  //     // ============================
  //     // 5) FINAL RECEIPT HTML
  //     // ============================
  //     const receiptHtml = `
  //     <html>
  //       <head>${printhtmlstyle}</head>
  //       <body>
  //         <div id="printelement" class="text-center">

  //           <div class="header">
  //             <h3>${finalInfo.CompanyName}</h3>
  //             ${addressBlock}
  //           </div>

  //           <hr>

  //           <center>
  //             <table class="item-table">
  //               <thead>
  //                 <tr class="btt">
  //                   <td class="text-left">ITEM</td>
  //                   <td class="text-center">QTY</td>
  //                   <td class="text-right">PRICE</td>
  //                 </tr>
  //               </thead>

  //               <tbody>
  //                 ${allItemRows}
  //                 <tr><td colspan="3"><hr></td></tr>

  //                 <tr><td class="text-left">Sub Total</td><td></td><td class="text-right">₹${orderDetails.subtotal.toFixed(
  //                   2
  //                 )}</td></tr>
  //                 <tr><td class="text-left">CGST</td><td></td><td class="text-right">₹${orderDetails.cgst.toFixed(
  //                   2
  //                 )}</td></tr>
  //                 <tr><td class="text-left">SGST</td><td></td><td class="text-right">₹${orderDetails.sgst.toFixed(
  //                   2
  //                 )}</td></tr>
  //                 <tr><td class="text-left">Total</td><td></td><td class="text-right">₹${orderDetails.total.toFixed(
  //                   2
  //                 )}</td></tr>
  //                 <tr><td class="text-left">Paid</td><td></td><td class="text-right">₹${orderDetails.paidAmount.toFixed(
  //                   2
  //                 )}</td></tr>
  //               </tbody>
  //             </table>
  //           </center>

  //           <hr>

  //           <div class="text-center"><p>Thank You. Visit Again.</p></div>
  //           <hr>

  //           <div class="text-center"><p>Receipt by Biz1Book.</p></div>
  //           <hr>

  //           <div><h4 class="token"> ${ordNo1}</h4></div
  //         </div>
  //       </body>
  //     </html>
  //   `;

  //     // ============================
  //     // 6) PRINT LOGIC
  //     // ============================
  //     if (window.electronAPI?.printReceipt) {
  //       window.electronAPI.printReceipt(receiptHtml);
  //     } else {
  //       const printWindow = window.open("", "_blank");
  //       if (printWindow) {
  //         printWindow.document.open();
  //         printWindow.document.write(receiptHtml);
  //         printWindow.document.close();

  //         setTimeout(() => {
  //           printWindow.print();
  //           printWindow.close();
  //         }, 500);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error printing receipt:", error);
  //   }
  // };

  const printReceiptCOD = async (invoiceNo, ordNo1) => {
    return new Promise(async (resolve, reject) => {
      const compId = localStorage.getItem("compId");
      const strId = localStorage.getItem("StoreId");

      const { phoneNum, cusName } = location.state || {};
      try {
        const data = await getdata(compId, strId);

        if (data?.datas?.length > 0) {
          const info = data.datas[0];
          setCompanyInfo({
            CompanyName: info.companyName,
            StoreName: info.storeName,
            Address: info.address,
            City: info.city,
            GsTno: info.gsTno,
            ContactNo: info.contactNo,
          });
        }

        // Wait for state to update before using companyInfo
        const finalInfo = {
          CompanyName: data.datas?.[0]?.printStrName || "",
          StoreName: data.datas?.[0]?.storeName || "",
          Address: data.datas?.[0]?.address || "",
          City: data.datas?.[0]?.city || "",
          GsTno: data.datas?.[0]?.gsTno || "",
          ContactNo: data.datas?.[0]?.contactNo || "",
        };

        // ============================
        // 3) HEADER DETAILS
        // ============================
        const lines = [
          finalInfo.Address,
          finalInfo.City,
          finalInfo.ContactNo,
          `GSTIN: ${finalInfo.GsTno}`,
          `Receipt: ${invoiceNo}`,
          orderDetails.orderDate,
          phoneNum && `Customer PhoneNo: ${phoneNum}`, //  only if phone exists
          cusName && `Customer: ${cusName}`,
          `Order Type: ${type}`,
          `Payment: ${"Not Paid"}`,
        ].filter(Boolean);

        const addressBlock = `<p>${lines.filter(Boolean).join("<br>")}</p>`;

        // ============================
        // 4) ITEM TABLE
        // ============================
        const allItemRows = orderDetails.items
          .map(
            (item) => `
        <tr>
          <td class="text-left">${item.Prod_Desc}</td>
          <td class="text-center">${item.Quantity}</td>
          <td class="text-right">₹${item.TotalAmount.toFixed(2)}</td>
        </tr>`,
          )
          .join("");

        // ============================
        // 5) FINAL RECEIPT HTML
        // ============================
        const receiptHtml = `
      <html>
        <head>${printhtmlstyle}</head>
        <body>
          <div id="printelement" class="text-center">

            <div class="header">
              <h3>${finalInfo.CompanyName}</h3>
              ${addressBlock}
            </div>

            <hr>
        <div class="not-paid-stamp">
  <span>NOT PAID</span>
</div>

            <center>
              <table class="item-table">
                <thead>
                  <tr class="btt">
                    <td class="text-left">ITEM</td>
                    <td class="text-center">QTY</td>
                    <td class="text-right">PRICE</td>
                  </tr>
                </thead>

                <tbody>
                  ${allItemRows}
                  <tr><td colspan="3"><hr></td></tr>

                  <tr><td class="text-left">Sub Total</td><td></td><td class="text-right">₹${orderDetails.subtotal.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">CGST</td><td></td><td class="text-right">₹${orderDetails.cgst.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">SGST</td><td></td><td class="text-right">₹${orderDetails.sgst.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">Total</td><td></td><td class="text-right">₹${orderDetails.total.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">Paid</td><td></td><td class="text-right">₹${"0.00"}</td></tr>
                </tbody>
              </table>
            </center>

            <hr>

            <div class="text-center"><p>Thank You. Visit Again.</p></div>
            <hr>

            <div class="text-center"><p>Receipt by Biz1Book.</p></div>
            <hr>



            <div><h4 class="token"> ${ordNo1}</h4></div>
   
          </div>
        </body>
      </html>
    `;

        // if (window.electronAPI?.printReceipt) {
        //   await window.electronAPI.printReceipt(receiptHtml);
        //   resolve();
        // } else {
        //   const printWindow = window.open("", "_blank");
        //   if (printWindow) {
        //     printWindow.document.open();
        //     printWindow.document.write(receiptHtml);
        //     printWindow.document.close();

        //     setTimeout(() => {
        //       printWindow.print();
        //       printWindow.close();
        //       resolve();
        //     }, 500);
        //   }
        // }

        if (window.electronAPI?.printReceipt) {
          console.log("📡 Using Electron API for receipt");
          await window.electronAPI.printReceipt(receiptHtml);
          resolve();
        } else {
          console.log("🌐 Using web fallback for receipt");

          // Use iframe method for web fallback
          const printIframe = document.createElement("iframe");
          printIframe.style.position = "fixed";
          printIframe.style.right = "0";
          printIframe.style.bottom = "0";
          printIframe.style.width = "0";
          printIframe.style.height = "0";
          printIframe.style.border = "none";
          printIframe.style.visibility = "hidden";

          document.body.appendChild(printIframe);

          const iframeDoc =
            printIframe.contentDocument || printIframe.contentWindow?.document;

          if (!iframeDoc) {
            console.error("❌ Could not create iframe document");
            reject("Could not create print document");
            return;
          }

          iframeDoc.open();
          iframeDoc.write(receiptHtml);
          iframeDoc.close();

          printIframe.onload = () => {
            try {
              printIframe.contentWindow?.focus();
              printIframe.contentWindow?.print();

              setTimeout(() => {
                document.body.removeChild(printIframe);
                resolve();
              }, 1000);
            } catch (error) {
              console.error("❌ Print error:", error);
              document.body.removeChild(printIframe);
              reject(error);
            }
          };

          setTimeout(() => {
            try {
              printIframe.contentWindow?.focus();
              printIframe.contentWindow?.print();

              setTimeout(() => {
                if (document.body.contains(printIframe)) {
                  document.body.removeChild(printIframe);
                }
                resolve();
              }, 1000);
            } catch (error) {
              console.error("❌ Print fallback error:", error);
              if (document.body.contains(printIframe)) {
                document.body.removeChild(printIframe);
              }
              reject(error);
            }
          }, 500);
        }
      } catch (error) {
        console.error("❌ Receipt Print Error:", error);
        reject(error);
      }
    });
  };

  const printReceipt = async (invoiceNo, ordNo1) => {
    return new Promise(async (resolve, reject) => {
      const compId = localStorage.getItem("compId");
      const strId = localStorage.getItem("StoreId");

      const { phoneNum, cusName } = location.state || {};
      try {
        const data = await getdata(compId, strId);

        if (data?.datas?.length > 0) {
          const info = data.datas[0];
          setCompanyInfo({
            CompanyName: info.companyName,
            StoreName: info.storeName,
            Address: info.address,
            City: info.city,
            GsTno: info.gsTno,
            ContactNo: info.contactNo,
          });
        }

        // Wait for state to update before using companyInfo
        const finalInfo = {
          CompanyName: data.datas?.[0]?.printStrName || "",
          StoreName: data.datas?.[0]?.storeName || "",
          Address: data.datas?.[0]?.address || "",
          City: data.datas?.[0]?.city || "",
          GsTno: data.datas?.[0]?.gsTno || "",
          ContactNo: data.datas?.[0]?.contactNo || "",
        };

        // ============================
        // 3) HEADER DETAILS
        // ============================
        const lines = [
          finalInfo.Address,
          finalInfo.City,
          finalInfo.ContactNo,
          `GSTIN: ${finalInfo.GsTno}`,
          `Receipt: ${invoiceNo}`,
          orderDetails.orderDate,
          phoneNum && `Customer PhoneNo: ${phoneNum}`, //  only if phone exists
          cusName && `Customer: ${cusName}`,
          `Order Type: ${type}`,
        ].filter(Boolean);

        const addressBlock = `<p>${lines.filter(Boolean).join("<br>")}</p>`;

        // ============================
        // 4) ITEM TABLE
        // ============================
        const allItemRows = orderDetails.items
          .map(
            (item) => `
        <tr>
          <td class="text-left">${item.Prod_Desc}</td>
          <td class="text-center">${item.Quantity}</td>
          <td class="text-right">₹${item.TotalAmount.toFixed(2)}</td>
        </tr>`,
          )
          .join("");

        // ============================
        // 5) FINAL RECEIPT HTML
        // ============================
        const receiptHtml = `
      <html>
        <head>${printhtmlstyle}</head>
        <body>
          <div id="printelement" class="text-center">

            <div class="header">
              <h3>${finalInfo.CompanyName}</h3>
              ${addressBlock}
            </div>

            <hr>

            <center>
              <table class="item-table">
                <thead>
                  <tr class="btt">
                    <td class="text-left">ITEM</td>
                    <td class="text-center">QTY</td>
                    <td class="text-right">PRICE</td>
                  </tr>
                </thead>

                <tbody>
                  ${allItemRows}
                  <tr><td colspan="3"><hr></td></tr>

                  <tr><td class="text-left">Sub Total</td><td></td><td class="text-right">₹${orderDetails.subtotal.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">CGST</td><td></td><td class="text-right">₹${orderDetails.cgst.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">SGST</td><td></td><td class="text-right">₹${orderDetails.sgst.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">Total</td><td></td><td class="text-right">₹${orderDetails.total.toFixed(
                    2,
                  )}</td></tr>
                  <tr><td class="text-left">Paid</td><td></td><td class="text-right">₹${orderDetails.paidAmount.toFixed(
                    2,
                  )}</td></tr>
                </tbody>
              </table>
            </center>

            <hr>

            <div class="text-center"><p>Thank You. Visit Again.</p></div>
            <hr>

            <div class="text-center"><p>Receipt by Biz1Book.</p></div>
            <hr>

            <div><h4 class="token"> ${ordNo1}</h4></div
          </div>
        </body>
      </html>
    `;

        // if (window.electronAPI?.printReceipt) {
        //   await window.electronAPI.printReceipt(receiptHtml);
        //   resolve();
        // } else {
        //   const printWindow = window.open("", "_blank");
        //   if (printWindow) {
        //     printWindow.document.open();
        //     printWindow.document.write(receiptHtml);
        //     printWindow.document.close();

        //     setTimeout(() => {
        //       printWindow.print();
        //       printWindow.close();
        //       resolve();
        //     }, 500);
        //   }
        // }

        if (window.electronAPI?.printReceipt) {
          console.log("📡 Using Electron API for receipt");
          await window.electronAPI.printReceipt(receiptHtml);
          resolve();
        } else {
          console.log("🌐 Using web fallback for receipt");

          // Use iframe method for web fallback
          const printIframe = document.createElement("iframe");
          printIframe.style.position = "fixed";
          printIframe.style.right = "0";
          printIframe.style.bottom = "0";
          printIframe.style.width = "0";
          printIframe.style.height = "0";
          printIframe.style.border = "none";
          printIframe.style.visibility = "hidden";

          document.body.appendChild(printIframe);

          const iframeDoc =
            printIframe.contentDocument || printIframe.contentWindow?.document;

          if (!iframeDoc) {
            console.error("❌ Could not create iframe document");
            reject("Could not create print document");
            return;
          }

          iframeDoc.open();
          iframeDoc.write(receiptHtml);
          iframeDoc.close();

          printIframe.onload = () => {
            try {
              printIframe.contentWindow?.focus();
              printIframe.contentWindow?.print();

              setTimeout(() => {
                document.body.removeChild(printIframe);
                resolve();
              }, 1000);
            } catch (error) {
              console.error("❌ Print error:", error);
              document.body.removeChild(printIframe);
              reject(error);
            }
          };

          setTimeout(() => {
            try {
              printIframe.contentWindow?.focus();
              printIframe.contentWindow?.print();

              setTimeout(() => {
                if (document.body.contains(printIframe)) {
                  document.body.removeChild(printIframe);
                }
                resolve();
              }, 1000);
            } catch (error) {
              console.error("❌ Print fallback error:", error);
              if (document.body.contains(printIframe)) {
                document.body.removeChild(printIframe);
              }
              reject(error);
            }
          }, 500);
        }
      } catch (error) {
        console.error("❌ Receipt Print Error:", error);
        reject(error);
      }
    });
  };

  const printkotReceipt = async (invoiceNo, ordNo1) => {
    try {
      const compId = localStorage.getItem("compId");
      const strId = localStorage.getItem("StoreId");
      const orderType = localStorage.getItem("orderType") || "Take Away";

      const data = await getdata(compId, strId);
      const info = data?.datas?.[0] || {};

      const finalInfo = {
        CompanyName: info.printStrName || "",
        StoreName: info.storeName || "",
        Address: info.address || "",
        City: info.city || "",
        GsTno: info.gsTno || "",
        ContactNo: info.contactNo || "",
      };

      /* ============================
       ITEM ROWS
    ============================ */
      const allItemRows = (orderDetails?.items || [])
        .map(
          (item) => `
          <tr>
            <td class="text-left">${item.Prod_Desc}</td>
            <td class="text-center">${item.Quantity}</td>
          </tr>
        `,
        )
        .join("");

      /* ============================
       PRINT STYLES
    ============================ */
      const printStylekot = `
      <style>
        @page { margin: 2px; }
      body, html { margin: 2px; padding: 2px; width: 100%;font-family: sans-serif; }

        #printkotelement {
          width: 270px;
          padding: 10px;
          
        }

        h3 {
          font-size: 18px;
          text-align: center;
          margin: 6px 0;
        }

        h2 {
          font-size: 14px;
          text-align: center;
          margin: 6px 0;
        }

        .header {
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          margin:0;
          
           
        }

        table {
          width: 100%;
          border-collapse: collapse;
            
        }

        thead {
          border-bottom: 1px dashed #000;
        }

        td {
          padding: 4px 0;
        }

        .text-left {
          text-align: left;
           font-size: 14px;
        }
           .time{
           margein-right:5px
           }

        .text-center {
          text-align: center;
           font-size: 14px;
        }

        hr {
          border-top: 1px dashed #000;
          margin: 8px 0;
        }

        .token {
          font-size: 1.8rem;
          font-weight: 900;
          text-align: center;
          margin: 10px auto;
          width: 200px;
          border: 2px ridge #000;
          border-radius: 6px;
          padding: 4px 0;
        }
      </style>
    `;

      /* ============================
       RECEIPT HTML
    ============================ */
      const receiptHtml = `
      <html>
        <head>
          ${printStylekot}
        </head>
        <body>
          <div id="printkotelement">
            <div class="token">${ordNo1}</div>
            <h3>#${invoiceNo}</h3>

            <hr/>

            <div class="header">
              <div>Order Type: ${orderType}</div>
              <div class="time">
                ${new Date().toLocaleString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </div>
            </div>
            <hr/>
    <h2>ORDER ITEMS</h2>
            
             <hr/>
            <table>
              <thead>
                <tr>
                  <td class="text-left">ITEM</td>
                  <td class="text-center">QTY</td>
                </tr>
              </thead>
              <tbody>
                ${allItemRows}
              </tbody>
            </table>

            <hr/>
            <div class="text-center">Receipt by Biz1Book</div>
          </div>
        </body>
      </html>
    `;

      console.log("🖨️ Printing KOT...");

      /* ============================
       ELECTRON PRINT
    ============================ */
      if (window.electronAPI?.printkotReceipt) {
        await window.electronAPI.printkotReceipt(receiptHtml);
        return;
      }

      if (window.electronAPI?.printReceipt) {
        await window.electronAPI.printReceipt(receiptHtml);
        return;
      }

      /* ============================
       WEB FALLBACK (IFRAME)
    ============================ */
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.style.visibility = "hidden";

      document.body.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) throw new Error("Unable to access print iframe");

      doc.open();
      doc.write(receiptHtml);
      doc.close();

      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();

        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      };
    } catch (error) {
      console.error("❌ KOT Print Error:", error);
      throw error;
    }
  };

  //   const printkotReceipt = async (invoiceNo, ordNo1) => {
  //   try {
  //     const compId = localStorage.getItem("compId");
  //     const strId = localStorage.getItem("StoreId");

  //     const { phoneNum, cusName } = location.state || {};
  //     const data = await getdata(compId, strId);

  //     const info = data?.datas?.[0] || {};

  //     const finalInfo = {
  //       CompanyName: info.printStrName || "",
  //       StoreName: info.storeName || "",
  //       Address: info.address || "",
  //       City: info.city || "",
  //       GsTno: info.gsTno || "",
  //       ContactNo: info.contactNo || "",
  //     };

  //     /* ============================
  //        ITEM ROWS
  //     ============================ */
  //     const allItemRows = orderDetails.items
  //       .map(
  //         (item) => `
  //         <tr>
  //           <td class="text-left">${item.Prod_Desc}</td>
  //           <td class="text-center">${item.Quantity}</td>
  //         </tr>`
  //       )
  //       .join("");

  //     /* ============================
  //        PRINT STYLE
  //     ============================ */
  //     const printhtmlstyle = `
  //       <style>
  //         @import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@500;600&display=swap');

  //         body {
  //           margin: 0;
  //           font-family: 'Comfortaa', sans-serif;
  //           font-size: 12px;
  //           font-weight: 600;
  //         }

  //         #printelement {
  //           width: 270px;
  //           padding: 10px;
  //         }

  //         h3 {
  //           font-size: 14px;
  //           text-align: center;
  //           margin: 5px 0;
  //         }

  //         .header {
  //           display: flex;
  //           justify-content: space-between;
  //           font-size: 12px;
  //           margin: 5px 0;
  //         }

  //         .item-table {
  //           width: 100%;
  //           border-collapse: collapse;
  //         }

  //         thead {
  //           border-bottom: 1px dashed black;
  //         }

  //         td {
  //           padding: 4px 0;
  //         }

  //         .text-left { text-align: left; }
  //         .text-center { text-align: center; }

  //         hr {
  //           border-top: 1px dashed black;
  //           margin: 8px 0;
  //         }
  //       </style>
  //     `;

  //     /* ============================
  //        RECEIPT HTML
  //     ============================ */
  //     const receiptHtml = `
  //       <html>
  //         <head>${printhtmlstyle}</head>
  //         <body>
  //           <div id="printelement">

  //             <h3>${finalInfo.CompanyName}</h3>
  //             <div class="text-center">${finalInfo.Address}</div>
  //             <div class="text-center">${finalInfo.City}</div>
  //             <div class="text-center">${finalInfo.ContactNo}</div>
  //             <div class="text-center">GSTIN: ${finalInfo.GsTno}</div>

  //             <hr>

  //             <div class="header">
  //               <div>Token: ${ordNo1}</div>
  //               <div>${new Date().toLocaleString()}</div>
  //             </div>

  //             <div class="header">
  //               <div>Receipt: ${invoiceNo}</div>
  //               <div>${orderDetails.orderDate}</div>
  //             </div>

  //             ${phoneNum ? `<div>Customer: ${cusName} (${phoneNum})</div>` : ""}

  //             <hr>

  //             <table class="item-table">
  //               <thead>
  //                 <tr>
  //                   <td class="text-left">ITEM</td>
  //                   <td class="text-center">QTY</td>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 ${allItemRows}
  //               </tbody>
  //             </table>

  //             <hr>
  //             <div class="text-center">Thank You. Visit Again.</div>
  //             <hr>
  //             <div class="text-center">Receipt by Biz1Book</div>

  //           </div>
  //         </body>
  //       </html>
  //     `;

  //     /* ============================
  //        PRINT
  //     ============================ */
  //     if (window.electronAPI?.printkotReceipt) {
  //       window.electronAPI.printkotReceipt(receiptHtml);
  //     } else {
  //       const printWindow = window.open("", "_blank");
  //       printWindow.document.write(receiptHtml);
  //       printWindow.document.close();
  //       setTimeout(() => {
  //         printWindow.print();
  //         printWindow.close();
  //       }, 500);
  //     }
  //   } catch (err) {
  //     console.error("Print Error:", err);
  //   }
  // };

  // const fetchPaymentStatustest = async () => {
  //   try {
  //     const orderResponse = await getorderno(storeId);
  //     console.log(orderResponse.getOrderIndex);

  //     const orderNoDine = orderResponse.getOrderIndex[0].orderno_DineIn || 0;
  //     const orderNoTake = orderResponse.getOrderIndex[0].orderno_TakeAway || 0;

  //     const type = localStorage.getItem("orderType");
  //     let ino = "";
  //     let ordNo = 0;
  //     let ordNo1 = 0;

  //     if (type === "Take Away") {
  //       ino = `SOS/T/${dateStr}/${orderNoTake}`;
  //       ordNo = orderNoTake;
  //       ordNo1 = "T-" + String(orderNoTake).padStart(2, "0");
  //     } else {
  //       ino = `SOS/D/${dateStr}/${orderNoDine}`;
  //       ordNo = orderNoDine;
  //       ordNo1 = "D-" + String(orderNoDine).padStart(2, "0");
  //     }

  //     if (orderResponse.status === 200) {
  //       const now = new Date();
  //       const date = now.getFullYear() + "-" +
  //                    String(now.getMonth() + 1).padStart(2, "0") + "-" +
  //                    String(now.getDate()).padStart(2, "0");
  //       const time24 = now.toLocaleTimeString("en-GB", { hour12: false });
  //       const dateTime = `${date}T${time24}`;

  //     const sosPayload = {
  //           OrderNo: parseInt(ordNo),
  //           UserId: 3,
  //           SourceId: 1,

  //           StoreId: parseInt(storeId),
  //           DeliverySoreId: parseInt(storeId),
  //           OrderTypeId: 14,
  //           Invoiceno: ino,
  //           CusId: parseInt(cstId),
  //           Custname: "Guest",
  //           Phoneno: parseInt(phone),
  //           Billamount: parseFloat(billAmount.toFixed(2)),
  //           TotalAmount: parseFloat(subtotal.toFixed(2)),
  //           Taxamount: parseFloat(taxAmount.toFixed(2)),
  //           Paidamount: parseFloat(billAmount.toFixed(2)),
  //           CompanyId: parseInt(CompId),
  //           PaymentTypeId: 1,
  //           OrderStatusId: 1,
  //           TransStatusId: 2,
  //           // Tax1: parseFloat((taxAmount / 2).toFixed(2)),
  //           // Tax2: parseFloat((taxAmount / 2).toFixed(2)),
  //           Tax1: parseFloat((parseFloat(taxAmount.toFixed(2)) / 2).toFixed(2)),
  //           Tax2: parseFloat((parseFloat(taxAmount.toFixed(2)) / 2).toFixed(2)),
  //           Tax3: 0,
  //           BillStatusId: 1,
  //           DiscPercent: 0,
  //           DiscAmount: 0,
  //           OrderTime: new Date().toLocaleTimeString("en-GB", {
  //             hour12: false,
  //           }),
  //           OrderedDateTime: dateTime,
  //           DeliveryTime: new Date().toLocaleTimeString("en-GB", {
  //             hour12: false,
  //           }),
  //           DeliveryDate: new Date().toISOString(),
  //           DeliveryDateTime: dateTime,
  //           CreatedDateTime: new Date().toISOString(),
  //           ModifiedDateTime: new Date().toISOString(),
  //           ItmJson: JSON.stringify(items),
  //           ChargeJson: Macadd,
  //         };

  //       const saveOrder = await SaveSosOrder(sosPayload);

  //       if (saveOrder.success === true) {
  //         // Print both receipts sequentially
  //         try {
  //           // 1️⃣ Print customer receipt first
  //           await printReceipt(sosPayload.Invoiceno, ordNo1);

  //           // 2️⃣ Small delay between prints (important for printer queue)
  //           await new Promise(resolve => setTimeout(resolve, 1000));

  //           // 3️⃣ Print KOT receipt
  //           await printkotReceipt(sosPayload.Invoiceno, ordNo1);

  //           // Navigate after both prints are done
  //           navigate("/popup", { state: { invoiceNo: sosPayload.Invoiceno } });

  //         } catch (printError) {
  //           console.error("Printing error:", printError);
  //           // Even if printing fails, navigate and show success
  //           navigate("/popup", { state: { invoiceNo: sosPayload.Invoiceno } });
  //         }

  //         // Clear storage
  //         localStorage.removeItem("cart");
  //         localStorage.removeItem("custid");
  //         localStorage.removeItem("userPhone");
  //         localStorage.removeItem("lastActiveCategory");
  //         localStorage.removeItem("selectedFreeItems");
  //         localStorage.removeItem("allowedFreeQty");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error processing order:", error);
  //   }
  // };

  const fetchPaymentStatustest = async () => {
    try {
      const orderResponse = await getorderno(storeId);
      console.log("Order Index Response:", orderResponse.getOrderIndex);

      const orderNoDine = orderResponse.getOrderIndex[0].orderno_DineIn || 0;
      const orderNoTake = orderResponse.getOrderIndex[0].orderno_TakeAway || 0;

      const type = localStorage.getItem("orderType");
      let ino = "";
      let ordNo = 0;
      let ordNo1 = "";

      if (type === "Take Away") {
        ino = `SOS/T/${dateStr}/${orderNoTake}`;
        ordNo = orderNoTake;
        ordNo1 = "T-" + String(orderNoTake).padStart(2, "0");
      } else {
        ino = `SOS/T/${dateStr}/${orderNoDine}`;
        ordNo = orderNoDine;
        ordNo1 = "T-" + String(orderNoDine).padStart(2, "0");
      }

      console.log("Invoice No:", ino);
      console.log("Display Order No:", ordNo1);

      if (orderResponse.status === 200) {
        const now = new Date();
        const date = `${now.getFullYear()}-${String(
          now.getMonth() + 1,
        ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

        const time24 = now.toLocaleTimeString("en-GB", { hour12: false });
        const dateTime = `${date}T${time24}`;

        const sosPayload = {
          qrId: qrId,
          PayOrdId: payOrdId,
          OrderedDate: new Date().toISOString().split("T")[0],
          OrderNo: parseInt(ordNo),
          UserId: 3,
          SourceId: 1,
          StoreId: parseInt(storeId),
          DeliverySoreId: parseInt(storeId),
          OrderTypeId: 14,
          Invoiceno: ino,
          CusId: parseInt(cstId),
          Custname: "Guest",
          Phoneno: parseInt(phone),
          Billamount: parseFloat(billAmount.toFixed(2)),
          TotalAmount: parseFloat(subtotal.toFixed(2)),
          Taxamount: parseFloat(taxAmount.toFixed(2)),
          Paidamount: parseFloat(billAmount.toFixed(2)),
          CompanyId: parseInt(CompId),
          PaymentTypeId: 1,
          OrderStatusId: 1,
          TransStatusId: 2,
          Tax1: parseFloat((taxAmount / 2).toFixed(2)),
          Tax2: parseFloat((taxAmount / 2).toFixed(2)),
          Tax3: 0,
          BillStatusId: 1,
          DiscPercent: 0,
          DiscAmount: 0,
          OrderTime: time24,
          OrderedDateTime: dateTime,
          DeliveryTime: time24,
          DeliveryDate: new Date().toISOString(),
          DeliveryDateTime: dateTime,
          CreatedDateTime: new Date().toISOString(),
          ModifiedDateTime: new Date().toISOString(),
          ItmJson: JSON.stringify(items),
          ChargeJson: Macadd,
        };

        console.log("Saving Order Payload:", sosPayload);

        // const saveOrder = await SaveSosOrder(sosPayload);

        // try {
        //   // 🖨️ CUSTOMER PRINTER
        //   console.log("🖨️ Printing Customer Receipt...");
        //   console.log("Customer Printer Data:", {
        //     invoice: sosPayload.Invoiceno,
        //     orderNo: ordNo1,
        //   });

        //   await printReceipt(sosPayload.Invoiceno, ordNo1);
        //   console.log("✅ Customer Receipt Printed");

        //   // Delay for printer buffer
        //   await new Promise((resolve) => setTimeout(resolve, 1000));

        //   // 🖨️ KOT PRINTER
        //   console.log("🖨️ Printing KOT Receipt...");
        //   console.log("KOT Printer Data:", {
        //     invoice: sosPayload.Invoiceno,
        //     orderNo: ordNo1,
        //   });

        //   await printkotReceipt(sosPayload.Invoiceno, ordNo1);
        //   console.log("✅ KOT Receipt Printed");

        //   navigate("/popup", {
        //     state: { invoiceNo: sosPayload.Invoiceno },
        //   });
        // } catch (printError) {
        //   console.error("❌ Printing Error:", printError);
        //   navigate("/popup", {
        //     state: { invoiceNo: sosPayload.Invoiceno },
        //   });
        // }

        // if (saveOrder.success === true) {
        //   try {
        //     // 🖨️ CUSTOMER PRINTER
        //     console.log("🖨️ Printing Customer Receipt...");
        //     console.log("Customer Printer Data:", {
        //       invoice: sosPayload.Invoiceno,
        //       orderNo: ordNo1,
        //     });

        //     await printReceipt(sosPayload.Invoiceno, ordNo1);
        //     console.log("✅ Customer Receipt Printed");

        //     // Delay for printer buffer
        //     await new Promise((resolve) => setTimeout(resolve, 1000));

        //     // 🖨️ KOT PRINTER
        //     console.log("🖨️ Printing KOT Receipt...");
        //     console.log("KOT Printer Data:", {
        //       invoice: sosPayload.Invoiceno,
        //       orderNo: ordNo1,
        //     });

        //     await printkotReceipt(sosPayload.Invoiceno, ordNo1);
        //     console.log("✅ KOT Receipt Printed");

        //     navigate("/popup", {
        //       state: { invoiceNo: sosPayload.Invoiceno },
        //     });
        //   } catch (printError) {
        //     console.error("❌ Printing Error:", printError);
        //     navigate("/popup", {
        //       state: { invoiceNo: sosPayload.Invoiceno },
        //     });
        //   }

        //   // Clear storage
        //   localStorage.removeItem("cart");
        //   localStorage.removeItem("custid");
        //   localStorage.removeItem("userPhone");
        //   localStorage.removeItem("lastActiveCategory");
        //   localStorage.removeItem("selectedFreeItems");
        //   localStorage.removeItem("allowedFreeQty");
        // }
      }
    } catch (error) {
      console.error("❌ Error processing order:", error);
    }
  };

  const casonpayorder = async () => {
    try {
      console.log(storeId);
      const orderResponse = await getorderno(storeId);
      console.log(orderResponse.getOrderIndex);
      const orderNo = orderResponse.getOrderIndex[0].ordNo || 0;
      console.log(orderNo);
      // const orderNoDine = orderResponse.getOrderIndex[0].GetOrderNo || 0;

      // const orderNoTake = orderResponse.getOrderIndex[0].orderno_TakeAway || 0;
      // console.log("🧾 OrderNo from API:", orderNoDine);
      // console.log("🧾 OrderNo from API:", orderNoTake);

      setMessage("✅ Payment Successful!");

      const type = localStorage.getItem("orderType");
      const typeiD = localStorage.getItem("ordertypeId");
      let ino = ""; // Declare outside the if/else so it's accessible later
      let ordNo = 0;
      let ordNo1 = 0;
      if (type === "Take Away") {
        ino = `SOS/T/${dateStr}/${orderNo}`;
        ordNo = orderNo;
        ordNo1 = "C-" + String(orderNo).padStart(2, "0");
      } else {
        ino = `SOS/D/${dateStr}/${orderNo}`;
        ordNo = orderNo;
        ordNo1 = "C-" + String(orderNo).padStart(2, "0");
      }
      console.log("Invoice No:", ino);
      console.log("Display Order No:", ordNo1);

      if (orderResponse.status === 200) {
        const now = new Date();
        const date = `${now.getFullYear()}-${String(
          now.getMonth() + 1,
        ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

        const time24 = now.toLocaleTimeString("en-GB", { hour12: false });
        const dateTime = `${date}T${time24}`;

        const sosPayload = {
          qrId: qrId,
          PayOrdId: "COD",
          OrderedDate: new Date().toISOString().split("T")[0],
          OrderNo: parseInt(ordNo),
          UserId: 3,
          SourceId: 1,
          StoreId: parseInt(storeId),
          DeliverySoreId: parseInt(storeId),
          OrderTypeId: 14,
          PrevStsId: typeiD,
          Invoiceno: ino,
          CusId: parseInt(cstId),
          Custname: "Guest",
          Phoneno: parseInt(phone),
          Billamount: parseFloat(billAmount.toFixed(2)),
          TotalAmount: parseFloat(subtotal.toFixed(2)),
          Taxamount: parseFloat(taxAmount.toFixed(2)),
          Paidamount: 0,
          CompanyId: parseInt(CompId),
          PaymentTypeId: 2,
          OrderStatusId: 1,
          TransStatusId: 2,
          Tax1: parseFloat((taxAmount / 2).toFixed(2)),
          Tax2: parseFloat((taxAmount / 2).toFixed(2)),
          Tax3: 0,
          BillStatusId: 1,
          DiscPercent: 0,
          DiscAmount: 0,
          OrderTime: time24,
          OrderedDateTime: dateTime,
          DeliveryTime: time24,
          DeliveryDate: new Date().toISOString(),
          DeliveryDateTime: dateTime,
          CreatedDateTime: new Date().toISOString(),
          ModifiedDateTime: new Date().toISOString(),
          ItmJson: JSON.stringify(items),
          ChargeJson: Macadd,
        };

        console.log("Saving Order Payload:", sosPayload);
        // await printReceiptCOD(sosPayload.Invoiceno, ordNo1);
        console.log(sosPayload);
        const saveOrder = await SaveSosOrder(sosPayload);
        console.log(saveOrder);
        if (saveOrder.success === true) {
          navigate("/popup", {
            state: { invoiceNo: sosPayload.Invoiceno },
          });
          if (saveOrder.success === true) {
            try {
              // 🖨️ CUSTOMER PRINTER
              console.log("🖨️ Printing Customer Receipt...");
              console.log("Customer Printer Data:", {
                invoice: sosPayload.Invoiceno,
                orderNo: ordNo1,
              });

              await printReceiptCOD(sosPayload.Invoiceno, ordNo1);
              console.log("✅ Customer Receipt Printed");

              // Delay for printer buffer
              await new Promise((resolve) => setTimeout(resolve, 1000));

              // 🖨️ KOT PRINTER
              console.log("🖨️ Printing KOT Receipt...");
              console.log("KOT Printer Data:", {
                invoice: sosPayload.Invoiceno,
                orderNo: ordNo1,
              });

              await printkotReceipt(sosPayload.Invoiceno, ordNo1);
              console.log("✅ KOT Receipt Printed");

              navigate("/popup", {
                state: { invoiceNo: sosPayload.Invoiceno },
              });
            } catch (printError) {
              console.error("❌ Printing Error:", printError);
              navigate("/popup", {
                state: { invoiceNo: sosPayload.Invoiceno },
              });
            }

            // Clear storage
            localStorage.removeItem("cart");
            localStorage.removeItem("custid");
            localStorage.removeItem("userPhone");
            localStorage.removeItem("lastActiveCategory");
            localStorage.removeItem("selectedFreeItems");
            localStorage.removeItem("allowedFreeQty");
          }
        }
      }
    } catch (error) {
      console.error("❌ Error processing order:", error);
    }
  };

  // ---------- Payment ----------
  const [showPopup, setShowPopup] = useState(false);

  const { qrImage } = location.state || {};
  const { payOrdId } = location.state || {};

  const canvasRef = useRef(null);


   const drawQrCorners = (ctx, x, y, size) => {
  const lineLength = 40;
  const lineWidth = 6;
  const color = "#D4A017"; // gold color like your image

  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;

  // Top-left
  ctx.beginPath();
  ctx.moveTo(x, y + lineLength);
  ctx.lineTo(x, y);
  ctx.lineTo(x + lineLength, y);
  ctx.stroke();

  // Top-right
  ctx.beginPath();
  ctx.moveTo(x + size - lineLength, y);
  ctx.lineTo(x + size, y);
  ctx.lineTo(x + size, y + lineLength);
  ctx.stroke();

  // Bottom-left
  ctx.beginPath();
  ctx.moveTo(x, y + size - lineLength);
  ctx.lineTo(x, y + size);
  ctx.lineTo(x + lineLength, y + size);
  ctx.stroke();

  // Bottom-right
  ctx.beginPath();
  ctx.moveTo(x + size - lineLength, y + size);
  ctx.lineTo(x + size, y + size);
  ctx.lineTo(x + size, y + size - lineLength);
  ctx.stroke();
};


  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const canvasWidth = 800;
    const canvasHeight = 800;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    drawBackground(ctx, canvasWidth, canvasHeight);

    ctx.textAlign = "center";

    // ------- BLACK TEXT (Payment + Accepted Here) --------
    ctx.fillStyle = "black";
    ctx.font = "bold 36px Arial";
    ctx.fillText("UPI Payment", canvasWidth / 2, 80);

    ctx.font = "22px Arial";
    ctx.fillText("Accepted Here", canvasWidth / 2, 120);

    // ------- TOTAL AMOUNT (ONLY WHITE) --------
    ctx.fillStyle = "white"; // total = white
    ctx.font = "bold 42px Arial";
    ctx.fillText(`Total: ₹ ${total}`, canvasWidth / 2, 170);
  }, [total]);

  // ----------------------------------------------------
  // BACKGROUND function (unchanged)
  // ----------------------------------------------------
  // const drawBackground = (ctx, canvasWidth, canvasHeight) => {
  //   // MAIN TEAL BACKGROUND
  //   ctx.fillStyle = "#1EA7A6";
  //   ctx.fillRect(0, 0, canvasWidth, canvasHeight);

  //   // WHITE CURVE
  //   ctx.fillStyle = "#ffffff";
  //   ctx.beginPath();
  //   ctx.moveTo(0, canvasHeight * 0.45);

  //   ctx.bezierCurveTo(
  //     canvasWidth * 0.25,
  //     canvasHeight * 0.3,
  //     canvasWidth * 0.75,
  //     canvasHeight * 0.3,
  //     canvasWidth,
  //     canvasHeight * 0.45,
  //   );

  //   ctx.lineTo(canvasWidth, canvasHeight);
  //   ctx.lineTo(0, canvasHeight);
  //   ctx.closePath();
  //   ctx.fill();
  // };

    const drawBackground = (ctx, canvasWidth, canvasHeight) => {
    ctx.fillStyle = "#ecd28f";
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    ctx.fillStyle = "#ffffff";
    ctx.beginPath();
    ctx.moveTo(0, canvasHeight * 0.45);
    ctx.bezierCurveTo(
      canvasWidth * 0.25,
      canvasHeight * 0.3,
      canvasWidth * 0.75,
      canvasHeight * 0.3,
      canvasWidth,
      canvasHeight * 0.45
    );
    ctx.lineTo(canvasWidth, canvasHeight);
    ctx.lineTo(0, canvasHeight);
    ctx.closePath();
    ctx.fill();
  };

  // ----------------------------------------------------
  // 2️⃣ Load QR image → Draw ONLY INSIDE grey box
  // ----------------------------------------------------
  // useEffect(() => {
  //   if (!qrImage) {
  //     setQrLoaded(false);
  //     return;
  //   }

  //   const canvas = canvasRef.current;
  //   if (!canvas) return;

  //   const ctx = canvas.getContext("2d");

  //   const img = new Image();
  //   img.src = qrImage;

  //   img.onload = () => {
  //     setQrLoaded(true);
  //     setStartTimer(true);

  //     // QR area positions
  //     const boxWidth = 550;
  //     const boxHeight = 550;
  //     const boxX = (800 - boxWidth) / 2;
  //     const boxY = 200;

  //     const qrSize = 500;
  //     const qrX = (800 - qrSize) / 2;
  //     const qrY = boxY + (boxHeight - qrSize) / 2;

  //     // Crop values
  //     const cropX = 108;
  //     const cropY = 630;
  //     const cropWidth = 458;
  //     const cropHeight = 450;

  //     // Draw QR inside grey box
  //     ctx.drawImage(
  //       img,
  //       cropX,
  //       cropY,
  //       cropWidth,
  //       cropHeight,
  //       qrX,
  //       qrY,
  //       qrSize,
  //       qrSize,
  //     );
  //   };
  // }, [qrImage]);


   useEffect(() => {
    if (!qrImage) {
      setQrLoaded(false);
      return;
    }

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.src = qrImage;

    img.onload = () => {
      setQrLoaded(true);
      setStartTimer(true);

      const boxWidth = 550;
      const boxHeight = 550;
      const boxX = (800 - boxWidth) / 2;
      const boxY = 200;

      const qrSize = 500;
      const qrX = (800 - qrSize) / 2;
      const qrY = boxY + (boxHeight - qrSize) / 2;

      const cropX = 108;
      const cropY = 630;
      const cropWidth = 458;
      const cropHeight = 450;

      ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, qrX, qrY, qrSize, qrSize);
      drawQrCorners(ctx, qrX, qrY, qrSize);
    };
  }, [qrImage]);

  useEffect(() => {
    if (showPopup) {
      // Burst confetti effect 🎉
      const duration = 2 * 1000;
      const end = Date.now() + duration;

      (function frame() {
        // Left side
        confetti({
          particleCount: 3,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors: ["#bb0000", "#ffffff", "#00ccff", "#ff69b4", "#00ff99"],
        });
        // Right side
        confetti({
          particleCount: 3,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors: ["#bb0000", "#ffffff", "#00ccff", "#ff69b4", "#00ff99"],
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    }
  }, [showPopup]);

  const [status, setStatus] = useState("PENDING");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const qrId = location.state?.qrId || "";
  useEffect(() => {
    console.log(qrId);
    if (!qrId) return;

    let interval;

    const fetchPaymentStatus = async () => {
      try {
        const response = await getqrdetails(qrId);
        console.log("Payment Status Response:", response);

        if (response && response.close_reason) {
          setStatus(response.close_reason);

          if (
            response.close_reason === "paid" ||
            response.close_reason === "SUCCESS"
          ) {
            const orderResponse = await getorderno(storeId);
            console.log(orderResponse.getOrderIndex);
            const orderNo = orderResponse.getOrderIndex[0].ordNo || 0;
            console.log(orderNo);
            // const orderNoDine =
            //   orderResponse.getOrderIndex[0].orderno_DineIn || 0;

            // const orderNoTake =
            //   orderResponse.getOrderIndex[0].orderno_TakeAway || 0;
            // console.log("🧾 OrderNo from API:", orderNoDine);
            setMessage("✅ Payment Successful!");
            clearInterval(interval);

            // const type = localStorage.getItem("orderType");
            // let ino = ""; // Declare outside the if/else so it's accessible later
            // let ordNo = 0;
            // let ordNo1 = 0;
            // if (type === "Take Away") {
            //   ino = `SOS/T/${dateStr}/${orderNoTake}`;
            //   ordNo = orderNoTake;
            //   ordNo1 = "T-" + String(orderNoTake).padStart(2, "0"); // T-01
            // } else {
            //   ino = `SOS/T/${dateStr}/${orderNoDine}`;
            //   ordNo = orderNoDine;
            //   ordNo1 = "T-" + String(orderNoDine).padStart(2, "0"); // D-01
            // }

            const type = localStorage.getItem("orderType");
            const typeiD = localStorage.getItem("ordertypeId");
            let ino = ""; // Declare outside the if/else so it's accessible later
            let ordNo = 0;
            let ordNo1 = 0;
            if (type === "Take Away") {
              ino = `SOS/T/${dateStr}/${orderNo}`;
              ordNo = orderNo;
              ordNo1 = "C-" + String(orderNo).padStart(2, "0");
            } else {
              ino = `SOS/D/${dateStr}/${orderNo}`;
              ordNo = orderNo;
              ordNo1 = "C-" + String(orderNo).padStart(2, "0");
            }
            console.log("Invoice No:", ino);
            console.log("Display Order No:", ordNo1);

            if (orderResponse.status === 200) {
              const now = new Date();

              // Format: YYYY-MM-DD
              const date =
                now.getFullYear() +
                "-" +
                String(now.getMonth() + 1).padStart(2, "0") +
                "-" +
                String(now.getDate()).padStart(2, "0");

              // Time (24-hour format)
              const time24 = now.toLocaleTimeString("en-GB", { hour12: false });

              // Final datetime
              const dateTime = `${date}T${time24}`;

              console.log(dateTime);

              const sosPayload = {
                qrId: qrId,
                OrderNo: parseInt(ordNo),
                UserId: 3,
                SourceId: 1,
                StoreId: parseInt(storeId),
                DeliverySoreId: parseInt(storeId),
                PayOrdId: payOrdId,
                OrderedDate: new Date().toISOString().split("T")[0],
                OrderTypeId: 14,
                PrevStsId: typeiD,
                Invoiceno: ino,
                CusId: parseInt(cstId),
                Custname: "Guest",
                Phoneno: parseInt(phone),
                Billamount: parseFloat(billAmount.toFixed(2)),
                TotalAmount: parseFloat(subtotal.toFixed(2)),
                Taxamount: parseFloat(taxAmount.toFixed(2)),
                Paidamount: parseFloat(billAmount.toFixed(2)),
                CompanyId: parseInt(CompId),
                PaymentTypeId: 1,
                OrderStatusId: 1,
                TransStatusId: 2,
                Tax1: parseFloat((taxAmount / 2).toFixed(2)),
                Tax2: parseFloat((taxAmount / 2).toFixed(2)),
                Tax3: 0,
                BillStatusId: 1,
                DiscPercent: 0,
                DiscAmount: 0,
                OrderTime: new Date().toLocaleTimeString("en-GB", {
                  hour12: false,
                }),
                OrderedDateTime: dateTime,
                DeliveryTime: new Date().toLocaleTimeString("en-GB", {
                  hour12: false,
                }),
                DeliveryDate: new Date().toISOString(),
                DeliveryDateTime: dateTime,
                CreatedDateTime: new Date().toISOString(),
                ModifiedDateTime: new Date().toISOString(),
                ItmJson: JSON.stringify(items),
                ChargeJson: Macadd,
              };
              console.log(sosPayload);
              const saveOrder = await SaveSosOrder(sosPayload);
              console.log(saveOrder);
              if (saveOrder.success === true) {
                navigate("/popup", {
                  state: { invoiceNo: sosPayload.Invoiceno },
                });
                if (saveOrder.success === true) {
                  try {
                    // 🖨️ CUSTOMER PRINTER
                    console.log("🖨️ Printing Customer Receipt...");
                    console.log("Customer Printer Data:", {
                      invoice: sosPayload.Invoiceno,
                      orderNo: ordNo1,
                    });

                    await printReceipt(sosPayload.Invoiceno, ordNo1);
                    console.log("✅ Customer Receipt Printed");

                    // Delay for printer buffer
                    await new Promise((resolve) => setTimeout(resolve, 1000));

                    // 🖨️ KOT PRINTER
                    console.log("🖨️ Printing KOT Receipt...");
                    console.log("KOT Printer Data:", {
                      invoice: sosPayload.Invoiceno,
                      orderNo: ordNo1,
                    });

                    await printkotReceipt(sosPayload.Invoiceno, ordNo1);
                    console.log("✅ KOT Receipt Printed");

                    navigate("/popup", {
                      state: { invoiceNo: sosPayload.Invoiceno },
                    });
                  } catch (printError) {
                    console.error("❌ Printing Error:", printError);
                    navigate("/popup", {
                      state: { invoiceNo: sosPayload.Invoiceno },
                    });
                  }

                  // Clear storage
                  localStorage.removeItem("cart");
                  localStorage.removeItem("custid");
                  localStorage.removeItem("userPhone");
                  localStorage.removeItem("lastActiveCategory");
                  localStorage.removeItem("selectedFreeItems");
                  localStorage.removeItem("allowedFreeQty");
                }
              }

              navigator.clipboard
                .writeText(JSON.stringify(sosPayload, null, 2))
                .then(() => console.log("✅ JSON copied to clipboard!"))
                .catch((err) => console.error("❌ Copy failed:", err));

              console.log("🧾 Final SOS Payload:", sosPayload);
            } else if (response.status === "FAILED") {
              setMessage("❌ Payment Failed. Please try again.");
              clearInterval(interval);
            }
          }
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
      } finally {
        setLoading(false);
      }
    };

    // Call every 3 seconds
    interval = setInterval(fetchPaymentStatus, 3000);
    fetchPaymentStatus(); // initial call immediately

    return () => clearInterval(interval); // cleanup when leaving page
  }, [qrId, navigate]);

  // const handleClose = () => {
  //   localStorage.removeItem("cart");
  //   localStorage.removeItem("orderType");
  //   localStorage.removeItem("custid");
  //   localStorage.removeItem("userPhone");
  //   navigate("/");
  // };

  // const CircularTimer = ({ initialSeconds = 120, onExtend }) => {
  //   const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
  //   const [showPopup, setShowPopup] = useState(false);

  //   useEffect(() => {
  //     if (secondsLeft <= 0) {
  //       setShowPopup(true);
  //       return;
  //     }

  //     const interval = setInterval(() => {
  //       setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
  //     }, 1000);

  //     return () => clearInterval(interval);
  //   }, [secondsLeft]);

  //   const minutes = Math.floor(secondsLeft / 60);
  //   const seconds = String(secondsLeft % 60).padStart(2, "0");

  //   const radius = 80;
  //   const circumference = 2 * Math.PI * radius;
  //   const progress = (secondsLeft / initialSeconds) * circumference;

  //   const handleExtend = () => {
  //     setShowPopup(false);
  //     setSecondsLeft(100); // restart with 100 sec
  //     if (onExtend) onExtend();
  //   };

  //   const handleCancel = () => {
  //     setShowPopup(false);
  //     navigate("/cart");
  //   };

  //   return (
  //     <>
  //       {/* TIMER UI */}
  //       <div className="relative w-48 h-48 mx-auto flex items-center justify-center mb-8">
  //         <svg className="absolute inset-0 w-full h-full -rotate-90">
  //           <circle
  //             cx="96"
  //             cy="96"
  //             r={radius}
  //             stroke="#F87171"
  //             strokeWidth="8"
  //             fill="none"
  //             opacity="0.2"
  //           />

  //           <circle
  //             cx="96"
  //             cy="96"
  //             r={radius}
  //             stroke="#db1515"
  //             strokeWidth="8"
  //             fill="none"
  //             strokeDasharray={circumference}
  //             strokeDashoffset={circumference - progress}
  //             strokeLinecap="round"
  //             style={{
  //               transition: "stroke-dashoffset 1s linear",
  //             }}
  //           />
  //         </svg>

  //         <span className="text-3xl font-semibold text-[#F87171] z-10">
  //           {minutes}:{seconds}
  //         </span>
  //       </div>

  //       {/* POPUP */}

  //       {showPopup && (
  //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[999]">
  //           <div className="bg-white p-8 rounded-2xl shadow-2xl w-[500px] h-[350px] text-center relative">
  //             {/* Icon */}
  //             <div className="flex justify-center mb-4">
  //               <div className="bg-red-100 p-4 rounded-full">

  //                  <TimerReset  size={18} className="h-20 w-20 text-red-600" />
  //               </div>
  //             </div>

  //             {/* Title */}
  //             <h2 className="text-2xl font-bold text-gray-900 mb-2">
  //               Time Expired
  //             </h2>

  //             {/* Message */}
  //             <p className="text-gray-600 mb-8">
  //               Need more time to complete the payment?
  //             </p>

  //             {/* Buttons */}
  //             <div className="flex items-center justify-center gap-6">
  //               <button
  //                 onClick={handleExtend}
  //                 className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md transition"
  //               >
  //                 Need More Time
  //               </button>

  //               <button
  //                 onClick={handleCancel}
  //                 className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-xl font-semibold shadow-md transition"
  //               >
  //                 Go Back
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </>
  //   );
  // };

  const CircularTimer = ({
    initialSeconds = 120,
    onExtend,
    qrId,
    startTimer,
  }) => {
    const navigate = useNavigate();
    const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
    const [showPopup, setShowPopup] = useState(false);
    const [extendedOnce, setExtendedOnce] = useState(false);

    useEffect(() => {
      if (!startTimer) return;
      if (secondsLeft <= 0) {
        const checkQrAndHandleExpiry = async () => {
          if (!extendedOnce) {
            // 🔥 IMPORTANT — use prop qrId (CORRECT)
            const response = await getqrdetails(qrId);

            if (response && response.close_reason === "") {
              setShowPopup(true); // QR active → allow extension
            } else {
              navigate("/cart"); // QR closed → force back
            }
          } else {
            navigate("/cart"); // second expiry → auto redirect
          }
        };

        checkQrAndHandleExpiry();
        return;
      }

      // countdown
      const interval = setInterval(() => {
        setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      return () => clearInterval(interval);
    }, [secondsLeft, extendedOnce, navigate, qrId]);

    // Extend Time by 100 Sec
    const handleExtend = () => {
      setShowPopup(false);
      setExtendedOnce(true);
      setSecondsLeft(100);

      if (onExtend) onExtend();
    };

    const handleCancel = () => {
      setShowPopup(false);
      navigate("/cart");
    };

    // UI values
    const minutes = Math.floor(secondsLeft / 60);
    const seconds = String(secondsLeft % 60).padStart(2, "0");

    const radius = 80;
    const circumference = 2 * Math.PI * radius;
    const progress = (secondsLeft / initialSeconds) * circumference;

    return (
      <>
        {/* TIMER UI */}
        <div className="relative w-48 h-48 mx-auto flex items-center justify-center">
          <svg className="absolute inset-0 w-full h-full -rotate-90">
            <circle
              cx="96"
              cy="96"
              r={radius}
              stroke="#F87171"
              strokeWidth="8"
              fill="none"
              opacity="0.2"
            />
            <circle
              cx="96"
              cy="96"
              r={radius}
              stroke="#db1515"
              strokeWidth="8"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={circumference - progress}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 1s linear" }}
            />
          </svg>

          <span className="text-3xl font-semibold text-[#F87171] z-10">
            {minutes}:{seconds}
          </span>
        </div>

        {/* POPUP ON FIRST EXPIRY */}
        {showPopup && !extendedOnce && (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[999]">
            <div className="bg-white p-8 rounded-2xl shadow-2xl w-[500px] h-[350px] text-center">
              <div className="flex justify-center mb-4">
                <div className="p-4 rounded-full">
                  <TimerReset size={18} className="h-20 w-20 text-red-600" />
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Time Expired
              </h2>

              <p className="text-gray-600 mb-8">
                Need more time to complete the payment?
              </p>

              <div className="flex items-center justify-center gap-6">
                <button
                  onClick={handleExtend}
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md transition"
                >
                  Need More Time
                </button>

                <button
                  onClick={handleCancel}
                  className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-xl font-semibold shadow-md transition"
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  {
    /* ---------------- PIN POPUP ---------------- */
  }

  const Logo = localStorage.getItem("logo");



  // ---------- UI ----------
  const companyName = localStorage.getItem("CompanyName");
  // return (
  //   <div className="min-h-screen bg-green-50 flex flex-col items-center justify-center px-4 relative">
  //     {/* Back Button */}
  //     <button
  //       onClick={() => navigate(-1)}
  //       style={{ zoom: "1.3" }}
  //       className="absolute top-6 left-6 flex items-center gap-2 bg-white text-red-700 px-3 py-2 rounded-full shadow-md hover:bg-gray-200 z-10"
  //     >
  //       <svg
  //         xmlns="http://www.w3.org/2000/svg"
  //         className="w-5 h-5"
  //         fill="none"
  //         viewBox="0 0 24 24"
  //         stroke="currentColor"
  //       >
  //         <path
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //           strokeWidth={2}
  //           d="M15 19l-7-7 7-7"
  //         />
  //       </svg>
  //       <span className="font-medium">Back</span>
  //     </button>

  //     {/* Top Logo + Company Name */}
  //     <div className="absolute top-6 left-1/2 -translate-x-1/2 flex items-center gap-4 text-red-700 px-3 py-2 z-10">
  //       <img
  //         src={
  //           Logo ||
  //           "https://bizdomfs.blob.core.windows.net/post-image/139a753e-0b57-41e3-ace6-9d2c4a866d24.png"
  //         }
  //         alt="Logo"
  //         className="w-20 h-20 rounded-full shadow-lg"
  //       />

  //       <h2 className="font-bold italic tracking-wide text-green-900 text-3xl">
  //         {companyName}
  //       </h2>
  //     </div>

  //     {/* Store Name – Bigger + Closer to Top */}
  //     <motion.div
  //       initial={{ y: -200, opacity: 0 }}
  //       animate={{ y: 0, opacity: 1 }}
  //       transition={{ duration: 0.8, ease: "easeOut" }}
  //     >
  //       {/* <div className="mt-24">
  //         <h2 className="font-bold italic tracking-wide text-green-900 text-center mb-10 text-6xl">
  //           {storeName}
  //         </h2>
  //       </div> */}
  //     </motion.div>

  //     {/* Timer */}
  //     <motion.div
  //       initial={{ y: -200, opacity: 0 }}
  //       animate={{ y: 0, opacity: 1 }}
  //       transition={{ duration: 0.8, ease: "easeOut" }}
  //     >
  //       <CircularTimer
  //         initialSeconds={120}
  //         startTimer={startTimer}
  //         qrId={location.state?.qrId}
  //       />
  //     </motion.div>

  //     {/* Heading */}
  //     {/* <motion.h1
  //       initial={{ opacity: 0, y: -20 }}
  //       animate={{ opacity: 1, y: 0 }}
  //       transition={{ duration: 0.6 }}
  //       className="text-4xl font-bold text-green-800 mt-4 mb-10"
  //     >
  //       Scan to Pay
  //     </motion.h1> */}

  //     <motion.h1
  //       initial={{ opacity: 0, y: -20 }}
  //       animate={{ opacity: 1, y: 0 }}
  //       transition={{ duration: 0.6 }}
  //       className="text-4xl font-bold text-green-800 mt-6 mb-10"
  //     >
  //       S
  //       <span onClick={() => handleSecretClick("c")} className="cursor-pointer">
  //         c
  //       </span>
  //       an{" "}
  //       <span
  //         onClick={() => handleSecretClick("to")}
  //         className="cursor-pointer"
  //       >
  //         to
  //       </span>{" "}
  //       <span
  //         onClick={() => handleSecretClick("pay")}
  //         className="cursor-pointer"
  //       >
  //         Pay
  //       </span>
  //     </motion.h1>

  //     {/* ---------------- PIN POPUP ---------------- */}

  //     {open && (
  //       <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
  //         <div className="bg-white rounded-2xl p-8 w-[520px] h-[550px]">
  //           <h2 className="text-2xl font-semibold text-center mb-6">
  //             Enter 4 Digit PIN
  //           </h2>

  //           <div className="flex justify-center gap-4 mb-4">
  //             {pin.map((d, i) => (
  //               <input
  //                 key={i}
  //                 value={d}
  //                 readOnly
  //                 type="password"
  //                 className="w-14 h-14 border text-center text-2xl rounded"
  //               />
  //             ))}
  //           </div>

  //           {error && <p className="text-red-500 text-center mb-2">{error}</p>}

  //           <Keyboard
  //             keyboardRef={(r) => (keyboardRef.current = r)}
  //             layout={{
  //               default: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {enter}"],
  //             }}
  //             className="number-keyboard"
  //             display={{
  //               "{bksp}": "⌫",
  //               "{enter}": "✔",
  //             }}
  //             onKeyPress={handleKeyboardPress}
  //           />
  //         </div>
  //       </div>
  //     )}
  //     {/* ---------------- SUCCESS POPUP ---------------- */}

  //     {showSuccessPopup && (
  //       <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
  //         <div className="bg-white rounded-2xl p-10 w-[540px] text-center relative">
  //           {/* Close Icon */}
  //           <button
  //             onClick={() => setShowSuccessPopup(false)}
  //             className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl font-bold"
  //           >
  //             ×
  //           </button>

  //           <h2 className="text-3xl text-green-600 font-bold mb-6">
  //             Access Granted
  //           </h2>

  //           <h5>
  //             This order will generate a COD receipt. The order is not paid.
  //             Please take the bill to the counter and pay the amount.
  //           </h5>

  //           <button
  //             onClick={casonpayorder}
  //             className="bg-green-500 mt-12 text-white px-8 py-3 rounded-xl"
  //           >
  //             Proceed To Cash Order
  //           </button>
  //         </div>
  //       </div>
  //     )}

  //     {/* 
  //     <motion.p
  //       initial={{ opacity: 0, y: 20 }}
  //       animate={{ opacity: 1, y: 0 }}
  //       transition={{ duration: 0.6, delay: 0.2 }}
  //       className="text-3xl text-gray-700 font-semibold mt-6 mb-6"
  //     >
  //       Total: ₹{" "}
  //       <span className="text-4xl font-extrabold" style={{ fontweight: 500 }}>
  //         {total}
  //       </span>
  //     </motion.p> */}

  //     {/* QR CANVAS + skeleton */}
  //     <motion.div
  //       initial={{ y: 250, opacity: 0 }}
  //       animate={{ y: 0, opacity: 1 }}
  //       transition={{ duration: 0.8, ease: "easeOut" }}
  //       className="relative"
  //     >
  //       {/* Canvas ALWAYS visible */}
  //       <canvas ref={canvasRef}></canvas>

  //       {/* Skeleton ONLY over QR box */}
  //       {!qrLoaded && (
  //         <div className="absolute top-[200px] left-1/2 -translate-x-1/2 w-[550px] h-[550px] bg-gray-200 rounded-md z-20 flex items-center justify-center">
  //           <div className="w-[500px] h-[500px] skeleton rounded-md"></div>
  //         </div>
  //       )}
  //     </motion.div>

  //     {/* <button
  //       onClick={fetchPaymentStatustest}
  //       className="mt-6 bg-green text-red-700 px-4 py-2 rounded-full shadow-md hover:bg-gray-200"
  //       style={{ zoom: "1.3" }}
  //     >
  //       Place Order
  //     </button> */}
  //   </div>
  // );

 const bgCanvasRef = useRef(null); // for animated background
  
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Animated background canvas */}
      <canvas ref={bgCanvasRef} className="absolute top-0 left-0 w-full h-full" />

      {/* Back Button */}



      {/* <button
        onClick={() => navigate(-1)}
        style={{ zoom: "1.3" }}
        className="absolute top-6 left-6 z-20 flex items-center gap-2 bg-white/20 backdrop-blur-md text-white px-4 py-2 rounded-full shadow-lg hover:bg-white/30 transition-all duration-300"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
           style={{color:"black"}}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        <span className="font-medium" style={{color:"black"}}>Back</span>
      </button> */}

<button
  onClick={() => navigate(-1)}
  style={{ zoom: "1.3" }}
  className="absolute top-6 left-6 z-20 flex items-center gap-2 bg-white text-[#b91c1c] px-4 py-2 rounded-full shadow-lg hover:bg-gray-100 transition-all duration-300"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19l-7-7 7-7"
    />
  </svg>
  <span className="font-medium">Back</span>
</button>

      {/* <button
        onClick={() => navigate(-1)}
        style={{ zoom: "1.3" }}
        className="absolute top-4 left-4 flex items-center gap-2 bg-white text-red-700 px-3 py-2 rounded-full shadow-md hover:bg-gray-200 z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        <span className="font-medium">Back</span>
      </button> */}


      {/* Logo and Company Name */}
      <div className="absolute top-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-4">
        <img
          src={Logo || "https://bizdomfs.blob.core.windows.net/post-image/139a753e-0b57-41e3-ace6-9d2c4a866d24.png"}
          alt="Logo"
          className="w-16 h-16 rounded-full shadow-lg border-2 border-white/30"
        />
        <h2 className="font-bold italic tracking-wide text-white text-3xl drop-shadow-lg" style={{ color: "black" }}>
          {companyName}
        </h2>
      </div>

      {/* Store Name */}
      {/* <div className="absolute top-24 left-1/2 -translate-x-1/2 z-20">
        <h4 className="font-bold italic text-white text-xl drop-shadow-lg whitespace-nowrap" style={{ color: "black" }}>
          {storeName}
        </h4>
      </div> */}

      {/* Main content container */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen pt-32 pb-12">
        {/* Timer with glow effect */}
        <div className="relative mb-8">
          <div className="absolute inset-0 rounded-full bg-green-300 blur-xl opacity-40 animate-ping"></div>
          <div className="relative bg-white shadow-xl rounded-full p-6 border border-green-200">
            <CircularTimer
              initialSeconds={120}
              startTimer={startTimer}
              qrId={location.state?.qrId}
            />
          </div>
        </div>

        {/* Scan to Pay Heading */}
        {/* <h1 className="text-3xl md:text-4xl font-bold text-green-800 mt-3 mb-12 text-center">
          S
          <span onClick={() => handleSecretClick("c")} className="cursor-pointer text-green-600 hover:text-red-500 transition duration-300">
            c
          </span>
          an{" "}
          <span onClick={() => handleSecretClick("to")} className="cursor-pointer text-green-600 hover:text-red-500 transition duration-300">
            to
          </span>{" "}
          <span onClick={() => handleSecretClick("pay")} className="cursor-pointer text-green-600 hover:text-red-500 transition duration-300">
            Pay
          </span>
        </h1> */}

{/* <h1 className="text-3xl md:text-4xl font-bold text-green-800 mt-3 mb-12 text-center relative z-30">
  S
  <span onClick={() => handleSecretClick("c")} className="cursor-pointer text-green-600 hover:text-red-500 transition duration-300">
    c
  </span>
  an{" "}
  <span onClick={() => handleSecretClick("to")} className="cursor-pointer text-green-600 hover:text-red-500 transition duration-300">
    to
  </span>{" "}
  <span onClick={() => handleSecretClick("pay")} className="cursor-pointer text-green-600 hover:text-red-500 transition duration-300">
    Pay
  </span>
</h1> */}




{/* <h1 className="text-5xl md:text-6xl font-extrabold mt-3 mb-8 text-center relative z-30 tracking-widest flex flex-col items-center leading-tight gap-1">
  <span className="text-[#D4A017] font-extrabold italic">
    SCAN
  </span>
  <span
    onClick={() => handleSecretClick("to")}
    className="cursor-pointer text-black font-extrabold"
  >
    TO
  </span>
  <span
    onClick={() => handleSecretClick("pay")}
    className="cursor-pointer text-black font-extrabold"
  >
    PAY
  </span>
</h1>  */}



{/* 
<h1 className="text-5xl md:text-6xl font-extrabold mt-3 mb-8 text-center relative z-30 tracking-widest flex flex-col items-center leading-tight gap-1">

  <span className="text-[#D4A017] font-extrabold italic">
    S
    <span
      onClick={() => handleSecretClick("c")} 
      className="cursor-pointer"
    >
      C
    </span>
    AN
  </span>

  <span
    onClick={() => handleSecretClick("to")}
    className="cursor-pointer text-black font-extrabold"
  >
    TO
  </span>

  <span
    onClick={() => handleSecretClick("pay")}
    className="cursor-pointer text-black font-extrabold"
  >
    PAY
  </span>

</h1> */}




<h1 className="text-center relative z-30 flex flex-col items-center leading-tight gap-1">

  {/* SCAN → BIGGEST 3D */}
  <span
    className="text-6xl md:text-7xl font-extrabold italic text-[#D4A017]"
    style={{
      textShadow: `
        0 2px 0 #b8860b,
        0 4px 0 #a67c00,
        0 6px 10px rgba(0,0,0,0.4),
        0 0 10px rgba(212,160,23,0.6),
        0 0 20px rgba(212,160,23,0.4)
      `,
    }}
  >
    S
    <span onClick={() => handleSecretClick("c")} className="cursor-pointer">
      C
    </span>
    AN
  </span>

  {/* TO → SMALL */}
  <span
    onClick={() => handleSecretClick("to")}
    className="cursor-pointer text-black font-extrabold text-2xl md:text-3xl"
    style={{
      textShadow: `
        0 2px 0 #999,
        0 4px 6px rgba(0,0,0,0.3)
      `,
    }}
  >
    TO
  </span>

  {/* PAY → MEDIUM */}
  <span
    onClick={() => handleSecretClick("pay")}
    className="cursor-pointer text-black font-extrabold text-4xl md:text-5xl"
    style={{
      textShadow: `
        0 2px 0 #999,
        0 4px 8px rgba(0,0,0,0.4),
        0 0 10px rgba(0,0,0,0.2)
      `,
    }}
  >
    PAY
  </span>

</h1>






        

        {/* QR Canvas */}
        <div className="relative" style={{marginTop:"20px"}}>
          <canvas ref={canvasRef} className="mx-auto" />
          {!qrLoaded && (
            <div className="absolute top-[200px] left-1/2 -translate-x-1/2 w-[550px] h-[550px] bg-gray-200 rounded-md z-20 flex items-center justify-center">
              <div className="w-[500px] h-[500px] skeleton rounded-md"></div>
            </div>
          )}
        </div>
      </div>

      {/* PIN Popup */}
      {/* {open && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl p-8 w-[520px] h-[550px]">
            <h2 className="text-2xl font-semibold text-center mb-6">Enter 4 Digit PIN</h2>
            <div className="flex justify-center gap-4 mb-4">
              {pin.map((d, i) => (
                <input
                  key={i}
                  value={d}
                  readOnly
                  type="password"
                  className="w-14 h-14 border text-center text-2xl rounded"
                />
              ))}
            </div>
            {error && <p className="text-red-500 text-center mb-2">{error}</p>}
            <Keyboard
              keyboardRef={(r) => (keyboardRef.current = r)}
              layout={{
                default: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {enter}"],
              }}
              className="number-keyboard"
              display={{
                "{bksp}": "⌫",
                "{enter}": "✔",
              }}
              onKeyPress={handleKeyboardPress}
            />
          </div>
        </div>
      )} */}




{/* PIN Popup */}
{open && (
  <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
    <div className="bg-white rounded-2xl p-8 w-[520px] h-[550px] relative">
      {/* Close button */}
      <button
        onClick={() => {
          setOpen(false);
          setPin(["", "", "", ""]);
          setError("");
        }}
        className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl font-bold"
      >
        ×
      </button>

      <h2 className="text-2xl font-semibold text-center mb-6">
        Enter 4 Digit PIN
      </h2>

      <div className="flex justify-center gap-4 mb-4">
        {pin.map((d, i) => (
          <input
            key={i}
            value={d}
            readOnly
            type="password"
            className="w-14 h-14 border text-center text-2xl rounded"
          />
        ))}
      </div>

      {error && <p className="text-red-500 text-center mb-2">{error}</p>}

      <Keyboard
        keyboardRef={(r) => (keyboardRef.current = r)}
        layout={{
          default: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {enter}"],
        }}
        className="number-keyboard"
        display={{
          "{bksp}": "⌫",
          "{enter}": "✔",
        }}
        onKeyPress={handleKeyboardPress}
      />
    </div>
  </div>
)}






      {/* Success Popup (COD) */}
      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl p-10 w-[540px] text-center relative">
            <button
              onClick={() => setShowSuccessPopup(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl font-bold"
            >
              ×
            </button>
            <h2 className="text-3xl text-green-600 font-bold mb-6">Access Granted</h2>
            <h5>
              This order will generate a COD receipt. The order is not paid.
              Please take the bill to the counter and pay the amount.
            </h5>
            <button
              onClick={casonpayorder}
              className="bg-green-500 mt-12 text-white px-8 py-3 rounded-xl"
            >
              Proceed To Cash Order
            </button>
          </div>
        </div>
      )}
    </div>
  );

}

export default CheckoutPage;
